/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientTargetModel } from '../../models/patient-target-model';

export interface GetPatientTargetContent$Params {
  targetID?: number;
}

export function GetPatientTargetContent(http: HttpClient, rootUrl: string, params?: GetPatientTargetContent$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientTargetModel>> {
  const rb = new RequestBuilder(rootUrl, GetPatientTargetContent.PATH, 'get');
  if (params) {
    rb.query('targetID', params.targetID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientTargetModel>;
    })
  );
}

GetPatientTargetContent.PATH = '/api/Supervisor/GetPatientTargetContent';
